<template>
  <div class="attachable-widget-component" v-bind:class="{loaded: loaded}">
    <div v-if="!loaded">
      <Skeleton class="skeleton" v-bind:loading="true"
                style="width: 100%;height: 46px;display: block; margin-bottom: 1px;"></Skeleton>
      <Skeleton class="skeleton" v-bind:loading="true"
                style="width: 100%;height: 46px;display: block;"></Skeleton>
    </div>
    <lazy-component v-on:intersected="onInit" v-bind:is-intersected="forceIntersect">
      <a-collapse>
        <a-collapse-panel v-for="(attachableCategory, key) in attachableCategories"
                          v-bind:key="attachableCategory.id"
                          v-bind:header="attachableCategory.name"
                          class="no-padding attachable-category" v-if="loaded">

          <template v-slot:extra>
            <a-badge
                v-if="getAttachableCount(key) > 0"
                v-bind:count="getAttachableCount(key)"
                v-bind:show-zero="true"
                v-bind:number-style="{ backgroundColor: 'red' }"
                title="Documenten"/>
          </template>
          <attachable-category-paginated-overview
              v-if="!attachableCategory.template"
              v-bind:customer-id="customerId"
              v-bind:attachable-category-id="attachableCategory.id"
              v-bind:publish-documents="canPublishDocuments"
              v-bind:has-attachable-type="hasAttachableType"
              v-bind:has-attachable-id="hasAttachableId"
              v-bind:count="getAttachableCount(key)"
              v-on:count-updated="onAttachableCategoryCountUpdated"
          ></attachable-category-paginated-overview>
          <attachable-category-template-placeholder
              v-if="attachableCategory.template"
              v-bind:customer-id="customerId"
              v-bind:attachable-category-template-id="attachableCategory.id"
              v-bind:publish-documents="canPublishDocuments"
              v-bind:has-attachable-type="hasAttachableType"
              v-bind:has-attachable-id="hasAttachableId"
              v-on:count-updated="onAttachableCategoryCountUpdated"
          ></attachable-category-template-placeholder>
        </a-collapse-panel>
        <a-collapse-panel key="notes" header="Notities" class="no-padding notes-panel" v-if="loaded">
          <template v-slot:extra>
            <a-badge
                v-if="noteCount > 0"
                v-bind:count="noteCount"
                v-bind:show-zero="false"
                v-bind:number-style="{ backgroundColor: 'red' }"
                title="Documenten"/>
          </template>
          <note-category-paginated-overview-component
              v-bind:instance="hasAttachableInstance"
              v-bind:category-id="category"
              v-bind:customer-id="customerId"
              v-bind:show-filter-options="false"
              v-bind:count="noteCount"
          ></note-category-paginated-overview-component>
        </a-collapse-panel>
      </a-collapse>
    </lazy-component>
  </div>
</template>

<script>
import attachableCategoryApi from '~/api/attachable_category'
import attachable from '~/api/attachable'
import { Skeleton } from 'vue-loading-skeleton'
import { IsAttachableTypeEnum } from '../../../enums'
import { mapGetters } from 'vuex'

export default {
  name: 'AttachableWidgetComponent',
  props: {
    hasAttachableType: {
      type: String,
      required: true
    },
    hasAttachableId: {
      type: [String, Number],
      required: true
    },
    customerId: {
      type: [String, Number],
      required: true
    },
    category: {
      type: Number,
      required: false,
      default: null
    },
    canPublishDocuments: {
      type: Boolean,
      required: false,
      default: false
    },
    isInstance: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    Skeleton,
  },
  data () {
    return {
      loaded: false,
      updateNameLoading: false,
      processLoading: false,
      unmatchLoading: false,
      activeAttachableCategory: null,
      attachableCategories: [],
      noteCount: 0
    }
  },
  computed: {
    ...mapGetters([
      'forceIntersect'
    ]),
    showLink () {
      return this.childInstance.show_link
    },
    hasCategory () {
      return this.category !== null
    },
    hasAttachableInstance () {
      return {
        id: this.hasAttachableId,
        type: this.hasAttachableType,
      }
    },
  },
  methods: {
    async onInit () {
      if (this.hasCategory && this.isInstance === false) {
        await attachableCategoryApi
            .getForHasAttachableAndCategory(this.hasAttachableType, this.hasAttachableId, this.category)
            .then(response => {
              this.attachableCategories = response.data
            })
      } else {
        await attachableCategoryApi
            .getForHasAttachable(this.hasAttachableType, this.hasAttachableId)
            .then(response => {
              this.attachableCategories = response.data
            })
      }

      attachable
          .countByInstanceAndChildClass(this.hasAttachableInstance, IsAttachableTypeEnum.NOTE)
          .then(response => {
            this.noteCount = response.data
          })

      this.loaded = true
    },
    getAttachableCount (key) {
      return this.attachableCategories[key]?.attachable_count?.data?.count || 0
    },
    handleCollapse (value) {
      this.activeAttachableCategory = value
    },
    onAttachableCategoryCountUpdated (attachableCategoryId, count) {
      const index = this.attachableCategories.findIndex(attachableCategory => attachableCategory.id === attachableCategoryId)
      let attachableCategory = this.attachableCategories[index]

      if (attachableCategory.template) {
        this.$nextTick(async () => {
          // TODO: fix collapse panel rerender bug before enabling
          // Vue.set(this.attachableCategories[index].attachable_count, {})
          // Vue.set(this.attachableCategories[index].attachable_count.data, {})
          // Vue.set(this.attachableCategories[index].attachable_count.data.count, count)
        })
      } else {
        Vue.set(this.attachableCategories[index].attachable_count.data.count, count)
      }
    }
  },
  created () {
  },
  mounted () {
  },
}
</script>

<style>

.attachable-widget-component {
}

.attachable-widget-component .notes-panel .ant-collapse-header,
.attachable-widget-component .attachable-category .ant-collapse-header {
  background-color: #98aebf !important;
  color: white !important;
}

</style>
